import { render } from "./IconCamera.vue?vue&type=template&id=650a3094"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconCamera.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "650a3094"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('650a3094', __exports__)) {
    api.reload('650a3094', __exports__)
  }
  
  module.hot.accept("./IconCamera.vue?vue&type=template&id=650a3094", () => {
    api.rerender('650a3094', render)
  })

}


export default __exports__